import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-to-top",
  "use": "various-to-top-usage",
  "viewBox": "0 0 14 17",
  "content": "<symbol viewBox=\"0 0 14 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-to-top\"><path d=\"M0 17L7 3l7 14H0zM0 2V0h14v2H0z\" fill=\"#FFF\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol